import { render, staticRenderFns } from "./ProductTileLayout.vue?vue&type=template&id=57cde36b&"
import script from "./ProductTileLayout.vue?vue&type=script&lang=ts&"
export * from "./ProductTileLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports